import React from 'react'

import OctaneLogo from '../Images/OctaneLogo'
import { DashboardItemProps } from '../types'
import { CaptionContainer, CaptionText } from './Caption.styled'

function Caption({ componentStyle, data }: DashboardItemProps) {
    return (
        <CaptionContainer componentStyle={componentStyle}>
            {data.showLogo && <OctaneLogo />}
            <CaptionText data-testid="CaptionText">{data.label}</CaptionText>
        </CaptionContainer>
    )
}

export default Caption
